export default class Module {
  constructor(mod = {}) {
    this.module_id = mod.module_id || 0;
    this.module_name = mod.module_name || "";
    this.module_code = mod.module_code || "";
    this.module_description = mod.module_description || "";
    this.module_formation = mod.module_formation || "";
    this.module_competence = mod.module_competence || "";
    this.module_modality = mod.module_modality || "";
    this.module_ucl = mod.module_ucl || "";
    this.module_year = mod.module_year || new Date().getFullYear();
    this.course_start_date = mod.course_start_date || new Date();
    this.course_end_date = mod.course_end_date || new Date();
    this.module_status = mod.module_status || false;
    this.teacher = mod.teacher || null;
    this.course_id = mod.course_id || 0;
    this.manual = mod.manual || null;
    this.description_evaluation_approval = mod.description_evaluation_approval || "";
  }
}



// WEBPACK FOOTER //
// ./src/models/module.model.js